/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Changelog_HeadingInputs */

const en_marketing_changelog_heading = /** @type {(inputs: Marketing_Changelog_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What shipped, when.`)
};

const es_marketing_changelog_heading = /** @type {(inputs: Marketing_Changelog_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué se lanzó y cuándo.`)
};

const fr_marketing_changelog_heading = /** @type {(inputs: Marketing_Changelog_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce qui a été livré, et quand.`)
};

/**
* | output |
* | --- |
* | "What shipped, when." |
*
* @param {Marketing_Changelog_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_changelog_heading = /** @type {((inputs?: Marketing_Changelog_HeadingInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Changelog_HeadingInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_changelog_heading(inputs)
	if (locale === "es") return es_marketing_changelog_heading(inputs)
	return fr_marketing_changelog_heading(inputs)
});